// src/api/config.ts

// Import PROMOFLOW_BASE_API_URL from endPoints
import { PROMOFLOW_BASE_API_URL } from './endPoints';

// API Configuration Constants
export const BASE_API_URL = PROMOFLOW_BASE_API_URL.promoflowUrl;

// Image upload API URL
export const IMAGE_UPLOAD_URL = import.meta.env.VITE_IMAGE_UPLOAD_URL || 'https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev';

// Voice AI URL for authentication redirects
export const VOICE_AI_URL = import.meta.env.VITE_VOICE_AI_URL;

// Request timeout (30 seconds)
export const REQUEST_TIMEOUT = 30000;

// API headers configuration
export const API_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
} as const;
